module.exports = __webpack_public_path__ + "img/share-jesus-a_2.png";